
<template>
       <div>
           <Support/>
       </div>
</template>

<script>
import Support from '../components/Support.vue';

export default {
    components: {
        Support
    }
};
</script>
<style scoped>


</style>